import React from "react";
import get from "lodash/get";
import InjectionMouldingTemplateCard from "./injectionMouldingTemplateCard";
import ExtrutionTemplateCard from "./extrutionTemplateCard";
import PunchPressTemplateCard from "./punchPressTemplateCard";
import CncTemplateCard from "./cncTemplateCard";

const DashboardTemplateCard = ({
  themeClasses,
  template,
  stats,
  isFullScreen,
  notificationStat,
  acknowledgeNotification
}) => {
  switch (get(template, "type.value")) {
    case 1:
      return (
        <InjectionMouldingTemplateCard
          themeClasses={themeClasses}
          template={template}
          stats={stats}
          notificationStat={notificationStat}
          isFullScreen={isFullScreen}
          acknowledgeNotification={acknowledgeNotification}
        />
      );
    case 2:
      return (
        <ExtrutionTemplateCard
          themeClasses={themeClasses}
          template={template}
          stats={stats}
          notificationStat={notificationStat}
          isFullScreen={isFullScreen}
        />
      );
    case 3:
      return (
        <PunchPressTemplateCard
          themeClasses={themeClasses}
          template={template}
          stats={stats}
          notificationStat={notificationStat}
          isFullScreen={isFullScreen}
        />
      );
    case 4:
      return (
        <CncTemplateCard
          themeClasses={themeClasses}
          template={template}
          stats={stats}
          notificationStat={notificationStat}
          isFullScreen={isFullScreen}
        />
      );
  }
};

export default DashboardTemplateCard;
